import docReducer from './';

export default docReducer;
